
import React, { useState } from 'react';

interface FaqItem {
  question: string;
  answer: string;
}

export const FaqSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems: FaqItem[] = [
    {
      question: "What is a VPN and why do I need one?",
      answer: "A VPN (Virtual Private Network) creates a secure, encrypted connection between your device and the internet. It protects your privacy, secures your data from hackers, and allows you to access content from anywhere in the world while keeping your online activities private."
    },
    {
      question: "How does DEN VPN protect my privacy?",
      answer: "Our VPN uses military-grade 256-bit AES encryption to secure your data. We maintain a strict no-log policy, meaning we never track, store, or monitor your online activities. Your browsing history, downloads, and personal information remain completely private."
    },
    {
      question: "Will using a VPN slow down my internet connection?",
      answer: "While VPNs can slightly reduce speed due to encryption overhead, our optimized global server network minimizes this impact. Many users experience minimal speed differences, and our smart routing technology ensures you get the fastest possible connection."
    },
    {
      question: "Can I use the VPN on multiple devices?",
      answer: "Yes! Our VPN service supports multiple devices simultaneously. You can protect your smartphone, laptop, tablet, and other devices with a single subscription. We offer native apps for Windows, Mac, iOS, Android, and browser extensions."
    },
    {
      question: "Is it legal to use a VPN?",
      answer: "VPNs are legal in most countries, including Croatia and the EU. However, laws vary by location, so we recommend checking your local regulations. VPNs are commonly used by businesses, individuals, and organizations worldwide for legitimate privacy and security purposes."
    },
    {
      question: "What happens if the VPN connection drops?",
      answer: "Our advanced kill switch feature automatically detects if your VPN connection is interrupted and immediately blocks all internet traffic until the secure connection is restored. This prevents any data leaks and ensures your privacy is never compromised."
    }
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-amber-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl text-gray-500 font-normal mb-2">Frequently Asked</h3>
          <h2 className="text-5xl text-gray-900 font-bold italic">Questions</h2>
        </div>
        
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden shadow-sm">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <h4 className="text-lg font-semibold text-gray-900 pr-4">
                  {item.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center transition-transform duration-300 ${
                  openIndex === index ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line text-purple-600 text-xl"></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6 animate-in slide-in-from-top-2 duration-300">
                  <p className="text-gray-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
